import classNames from 'classnames';

interface Props {
  Icon: React.FC<{ className: string }>;
  onClick?: () => void;
  variant?: 'primary' | 'secondary';
}
const IconButton: React.FC<Props> = ({
  Icon,
  onClick,
  variant = 'primary',
  ...rest
}) => {
  const buttonClassName = classNames(
    'flex items-center justify-center cursor-pointer rounded-lg  h-8 w-8 transition-all ',
    {
      ' bg-secondary-light  text-secondary  hover:text-white hover:bg-secondary-dark group-hover:text-white':
        variant === 'primary',
      'bg-gray-100 text-gray-new  hover:text-black hover:bg-gray-200':
        variant === 'secondary',
    }
  );
  return (
    <button
      type="button"
      onClick={onClick}
      className={buttonClassName}
      {...rest}
    >
      <Icon className="h-5 w-5" />
    </button>
  );
};

export default IconButton;
